export default __webpack_public_path__ + "static/healthy_girl-efb3299c42e81e775aa7cb24f2eafec1.svg";